export var Text = {
    variants: {
        tinyTitle: {
            fontSize: 'sm',
            color: 'gray.600',
            fontWeight: 'medium',
        },
    },
};
